import React from 'react';
import * as dateFns from 'date-fns';
import { Link } from 'react-router-dom';

import GameStats from './GameStats';
import ToolTip from '../../../Tooltip/Tooltip';
import { selectedPracticeRoute } from '../../../../../helpers';
import { TEAMS_COLORS, TEAMS_NAMES } from '../../../../../config/constants';
import { useRouter } from '../../../../../helpers/customHooks';
import { useUserState } from '../../../../../store/hooks';
import { GamePropsType } from '../types';

import './Event.scss';

const Game = ({ event, disabled, games }: GamePropsType) => {
  
  const { pathname } = useRouter();
  const user = useUserState();
  // const [showToolTip, setShowToolTip] = useState(-1);
  
  const startPosition = dateFns.getMinutes(event.startTime) * 1.1;
  const homeTeamName = TEAMS_NAMES.reduce(((result, team) => (team.short === event.homeTeamAbbr ? team : result)), {
    name: 'default',
    short: 'DEF'
  });
  const visitorTeamName = TEAMS_NAMES.reduce(((result, team) => (team.short === event.visitorTeamAbbr ? team : result)), {
    name: 'default',
    short: 'DEF'
  });
  
  return (
    <Link to={{ pathname: selectedPracticeRoute(pathname, event, user), state: { toReturn: pathname } }}>
      <div id='game-card' className="event-card" style={{
        ...(disabled ? {
          color: 'gray',
          marginTop: `${startPosition}px`
        } : { marginTop: `${startPosition}px` }), overflow: 'visible'
      }}>
        <div>
          <div className="eveny-g">@</div>
          <div
            className="event-l"
            style={{ background: `${TEAMS_COLORS[event.homeTeamAbbr] ? TEAMS_COLORS[event.homeTeamAbbr].text : TEAMS_COLORS['default'].text}` }}
          >
            <div className="event-h">
              <h6 className={event.homeTeamScoreTotal > event.visitorTeamScoreTotal ? 'label-bold' : ''}>
                {homeTeamName.name.split(' ')[homeTeamName.name.split(' ').length - 1]}
              </h6>
              <p className={event.homeTeamScoreTotal > event.visitorTeamScoreTotal ? 'label-bold' : ''}>
                <img src={'/assets/images/logos/' + event.homeTeamAbbr + '.svg'} width="24px" alt="" />
                {event.homeTeamScoreTotal}
              </p>
            </div>
          </div>
          <div className="event-r" style={{ background: `${TEAMS_COLORS[event.visitorTeamAbbr].text}` }}>
            <div className="event-h">
              <h6 className={event.homeTeamScoreTotal < event.visitorTeamScoreTotal ? 'label-bold' : ''}>
                {visitorTeamName.name.split(' ')[visitorTeamName.name.split(' ').length - 1]}
              </h6>
              <p className={event.homeTeamScoreTotal < event.visitorTeamScoreTotal ? 'label-bold' : ''}>
                {event.visitorTeamScoreTotal}
                <img src={'/assets/images/logos/' + event.visitorTeamAbbr + '.svg'} width="24px" alt="" />
              </p>
            </div>
          </div>
          <div className="event-b">
            <GameStats
              label='AVG. TOTAL DIST. (YDS)'
              colorA={TEAMS_COLORS[event.homeTeamAbbr].text}
              colorB={TEAMS_COLORS[event.visitorTeamAbbr].text}
              statA={event.dist.A}
              statB={event.dist.B}
            />
            <GameStats
              label='AVG. MAX SUST. SPEED (MPH)'
              colorA={TEAMS_COLORS[event.homeTeamAbbr].text}
              colorB={TEAMS_COLORS[event.visitorTeamAbbr].text}
              statA={event.speed.A}
              statB={event.speed.B}
            />
            <GameStats
              label='AVG. HARD EFFORT DIST. (YDS)'
              colorA={TEAMS_COLORS[event.homeTeamAbbr].text}
              colorB={TEAMS_COLORS[event.visitorTeamAbbr].text}
              statA={event.effort.A}
              statB={event.effort.B}
            />
          </div>
        </div>
        {games.length > 0 && (
          <div style={{ borderTop: '1px solid #778892' }}>
            <ToolTip
              moreEvents={games}
              tooltipData
              margin
              // setShowToolTip={setShowToolTip}
              // showToolTip={showToolTip}
            />
          </div>
        )}
      </div>
    </Link>
  );
};

export default Game;
